export const LessonReport = {
  Template: {
    GradeScale: {
      normal: ['A', 'B', 'C', 'D', 'F'],
      detailed: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'],
    },
  },
};
